<template>
  <div class="fme-small-card">
    <router-link :to="{ name: cardUrl }" class="fme-montserrat-font router-anchor">
      <div class="fme-small-base-card">
        <div class="row">
          <div class="col-md-8">
          <CardTitleLabel :titletext="cardTitle" :cardType="cardType" class="fme-small-card__title" :class="['fme-small-card__title--overview']" />
          </div>
          <div class="col-md-4">
          <div class="fme-small-card__number">
            <slot name="number"></slot>
          </div>
          </div>
          <!-- <CardMoreLink :linkMoretext="cardMoreLink" :cardType="cardType" class="fme-small-card__link-more" /> -->
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
const CardTitleLabel = () => import('@/components/fragment/card/CardTitleLabel')
// const CardMoreLink = () => import('@/components/fragment/card/CardMoreLink')

export default {
  name: 'BaseSmallCard',
  data () {
    return {
      largeTitleClass: 'base-card__title-large',
      smallTitleClass: 'base-card__title-small'
    }
  },
  props: {
    cardTitle: {
      type: String,
      required: true
    },
    cardMoreLink: {
      type: String,
      required: true
    },
    cardType: {
      type: String,
      validator: function (value) {
        return ['small', 'large', 'overview'].indexOf(value) !== -1
      }
    },
    cardUrl: String
  },
  components: {
    CardTitleLabel
    // CardMoreLink
  },
  computed: {
  },
  methods: {
  },
  filters: {
  },
  watch: {
  }
}
</script>

<style lang="scss">
.fme-small-card {
  margin-bottom: 2px;
  a {
    text-decoration: none;
    color: $fme-color__yale-blue;
    .fme-small-card__title {
      white-space: nowrap;
      p {
        //  margin: 0 0 53px 0;
         font-size: 18px;
      }
    }
    &:hover {
      .fme-small-card__title {
        color: $fme-color__celestial-blue;
      }
    }
    &.router-link-exact-active {
      .fme-small-card__title {
        color: $fme-color__celestial-blue;
      }
      // .fme-small-base-card {
      //   -webkit-box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
      //      -moz-box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
      //           box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
      // }
    }
    .fme-small-base-card {
      // min-height: 80px;
      max-height: 45px;
      position: relative;
      overflow: hidden;
      border-radius: 10px;
      background: $fme-color__write;
      padding: 10px 15px;
      -webkit-box-shadow: 0px 2px 4px 2px rgba(0,0,0,0.09);
         -moz-box-shadow: 0px 2px 4px 2px rgba(0,0,0,0.09);
              box-shadow: 0px 2px 4px 2px rgba(0,0,0,0.09);
      transition: box-shadow 0.3s ease-in-out;
      &:hover {
        -webkit-box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
           -moz-box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
                box-shadow: 0px 3px 10px 2px rgba(68,149,209,0.3);
      }
      .fme-small-card__number {
        right: 0;
        text-align: right !important;
        color: $fme-color__flame;
        h1 {
          font-weight: bold;
          font-size: 24px;
          margin: 0;
        }
      }
      .fme-small-card__numberpercent {
        position: absolute;
        right: 15px;
        bottom: 20px;
        color: $fme-color__flame;
        text-align: right;
        div {
          display: inline-block;
          height: 42px;
          max-height: 42px;
          font-family: 'Hind', sans-serif;
          margin-bottom: 0;
          font-weight: 400;
          span {
            display: inline-block;
            &:nth-child(1) {
              font-size: 22px;
              vertical-align: top;
              padding-top: 5px;
              padding-right: 3px;
            }
            &:nth-child(2) {
              font-size: 38px;
              font-weight: 600;
            }
          }
        }
        h3 {
          font-family: 'Montserrat', sans-serif;
          font-weight: 400;
          font-size: 23px;
              margin-top: -3px;
        }
      }
    }
  }
}
</style>
